import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@axa-asia/emma-stylesheet/lib/components/Modal';
import { getEmmaTncStyleModelAttributes } from '../../../selectors/uiSelectors';

import { resolvePublicAssets } from '../../../utils';

import { closeTncStyleModel } from '../../../actions/uiActions';
import './styles.scss';
import { t } from '../../../locales';
import { trackCloseButtonClick } from '../../../utils/generalGaEventAnalytics';

interface EmmaTncStyleModelProps {
  dialog: any;
  closeDialog: any;
  okDialog: any;
}

interface EmmaTncStyleModelState {}

class EmmaTncStyleModel extends Component<
  EmmaTncStyleModelProps,
  EmmaTncStyleModelState
> {
  constructor(props: EmmaTncStyleModelProps) {
    super(props);
  }

  onClickOkBtn() {
    const { dialog, okDialog } = this.props;
    okDialog(dialog.okAction);

    try {
      // The TNC close button GA event should only be available for Tnc disclaimar.
      // So put a checking here just in case that in the further this Tnc modal has other purpose e.g. non-TNC use case.
      // And in this TNC, ok button means close the modal
      const disclaimerId = dialog.disclaimerId;
      if (
        disclaimerId.substr(disclaimerId.length - 3).toUpperCase() === 'TNC'
      ) {
        trackCloseButtonClick(
          disclaimerId,
          disclaimerId,
          dialog.okButtonText || 'OK',
        );
      }
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    const { dialog, closeDialog, okDialog } = this.props;

    let header,
      modalClass,
      okButton,
      closeButton,
      otherButton,
      additionBodyClass,
      tncToggle: Array<any> = [];
    if (dialog) {
      const okButtonText = dialog.okButtonText ? dialog.okButtonText : 'OK';
      const otherButtonText = dialog.otherButtonText
        ? dialog.otherButtonText
        : '';
      if (dialog.tncToggle && dialog.tncToggle.length > 0) {
        dialog.tncToggle.map((item: { label: string; title: string }) => {
          const tncItem = (
            <div className="emma-tnc-style-modal_tnc-toggle-li">
              <div className="emma-tnc-style-modal_tnc-toggle-li_label">
                <span className="emma-tnc-style-modal_tnc-toggle-li_span">
                  {item.label}
                </span>
                <span className="emma-tnc-style-modal_tnc-toggle-li_title">
                  {item.title}
                </span>
              </div>
              <div className="emma-tnc-style-modal_tnc-toggle-li-checkbox"></div>
            </div>
          );
          tncToggle.push(tncItem);
        });
      }
      if (dialog.modalType === 'lockedModal') {
        header = (
          <div
            dangerouslySetInnerHTML={{ __html: memoSanitize(dialog.title) }}
          ></div>
        );
        modalClass = 'emma-tnc-style-modal emma-tnc-style-modal-locked';
        if (dialog.okAction) {
          okButton = (
            <button
              className="emma-stylesheet-primary-default-button"
              onClick={() => {
                this.onClickOkBtn();
              }}
              data-enable-ga
              data-ga-type="button"
            >
              {okButtonText}
            </button>
          );
        }
        if (dialog.closeAction) {
          closeButton = (
            <button
              className="emma-tnc-style-modal-locked__close"
              onClick={() => closeDialog(dialog.closeAction)}
              data-enable-ga
              data-ga-type="button"
            >
              {' '}
              {t('CLOSE')}{' '}
            </button>
          );
        }
      } else {
        header = <div>{dialog.title}</div>;
        modalClass = 'emma-tnc-style-modal';
        okButton = (
          <button
            className="emma-stylesheet-primary-default-button"
            onClick={() => {
              this.onClickOkBtn();
            }}
            data-enable-ga
            data-ga-type="button"
          >
            {okButtonText}
          </button>
        );
      }
    }

    return (
      <div>
        {dialog && (
          <Modal show={dialog.visible}>
            <ModalHeader>{header}</ModalHeader>
            <ModalBody>
              <div
                className="emma-tnc-style-modal__body"
                dangerouslySetInnerHTML={{ __html: memoSanitize(dialog.body) }}
              ></div>
              <div className="emma-tnc-style-modal_tnc-toggle-content">
                {tncToggle}
              </div>
            </ModalBody>
            <ModalFooter>
              <div className="emma-tnc-style-modal__btn-wrap">
                <div>{okButton}</div>
                {otherButton && <div className="mt8">{otherButton}</div>}
              </div>
            </ModalFooter>
          </Modal>
        )}
      </div>
    );
  }

  static mapStateToProps(state: any) {
    return {
      dialog: Object.assign({}, getEmmaTncStyleModelAttributes(state)),
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      closeDialog: (payload: any) => dispatch(closeTncStyleModel(payload)),
      okDialog: (payload: any) => dispatch(closeTncStyleModel(payload)),
    };
  }
}

export default connect(
  EmmaTncStyleModel.mapStateToProps,
  EmmaTncStyleModel.mapDispatchToProps,
)(EmmaTncStyleModel);
